import type {
  GetTradesParams,
  TradeListResponse,
  TradingStrategyOption,
} from "@/types/trading"
import client from "./client"

export async function getTradingOptions(): Promise<TradingStrategyOption[]> {
  const { data } = await client.get<TradingStrategyOption[]>("/api/trading/options")
  return data
}

export async function updateTradingOptions(payload: TradingStrategyOption[]): Promise<void> {
  await client.put("/api/trading/options", payload)
}

export async function getTrades(params: GetTradesParams): Promise<TradeListResponse> {
  const { data } = await client.get<TradeListResponse>("/api/trades", { params })
  return data
}
